import { create } from "zustand";
import { immer } from "zustand/middleware/immer";

import {
  fetchGroups,
  type Group,
  type Step,
  type Subsource,
} from "@/services/groups";

export type UseGroupsStepsState = {
  groups: Group[];
  selectedGroup: Group | null;
  selectedSubsource: Subsource | null;
  selectedStep: Step | null;
};

export type UseGroupsStepsActions = {
  selectGroup: (group: Group) => void;
  selectSubsource: (step: Subsource) => void;
  selectStep: (step: Step) => void;
  fetchGroups: () => Promise<void>;
  clear: () => void;
  loadingFetchGroups: boolean;
};

export const useGroupsSteps = create<
  UseGroupsStepsState & UseGroupsStepsActions
>()(
  immer((set, get) => ({
    groups: [],
    selectedGroup: null,
    selectedSubsource: null,
    selectedStep: null,
    loadingFetchGroups: false,
    fetchGroups: async () => {
      const { loadingFetchGroups } = get();
      if (loadingFetchGroups) return;
      set((state) => {
        state.loadingFetchGroups = true;
      });
      const { data } = await fetchGroups();
      set((state) => {
        state.groups = data;
        state.selectedGroup = data[0];
        state.selectedSubsource = data[0].subsources[0];
        state.selectedStep = data[0].steps[0];
        state.loadingFetchGroups = false;
      });
    },
    selectGroup: (group) => {
      set((state) => {
        state.selectedGroup = group;
        state.selectedSubsource = group.subsources[0];
        state.selectedStep = group.steps[0];
      });
    },
    selectSubsource: (subsource) => {
      set((state) => {
        state.selectedSubsource = subsource;
      });
    },
    selectStep: (step) => {
      set((state) => {
        state.selectedStep = step;
      });
    },
    clear: () => {
      set((state) => {
        state.selectedGroup = null;
        state.selectedSubsource = null;
        state.selectedStep = null;
        state.groups = [];
      });
    },
  })),
);
